module.exports = __webpack_public_path__ + "static/media/IMPORT_BULK_UPLOAD_3.00.6afe3859.xlsx";